import React, { useState } from "react";
import { authApi } from "@/pages/api/authentificationApi";
import styles from "./SocialLogin.module.css";

const SocialLogin: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleGoogleSignIn = async () => {
    setIsLoading(true);
    try {
      await authApi.loginWithGoogle();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.divider}>
        <span>ou continuer avec</span>
      </div>

      <div className={styles.socialButtons}>
        <button
          className={`${styles.button} ${styles.google}`}
          onClick={handleGoogleSignIn}
          disabled={isLoading}
        >
          <img
            src="https://www.google.com/favicon.ico"
            alt="Google"
            className={styles.icon}
          />
          {isLoading ? "Connexion..." : "Google"}
        </button>
      </div>
    </div>
  );
};

export default SocialLogin;
